import { Controller } from "@hotwired/stimulus"

// Maps a 5-stop range slider to a min_match float and live message.
// Wire with data-controller="match-slider"
//          data-match-slider-values-value='[["0.0","Anything goes","We'll show recipes for almost any pantry"], ...]'
export default class extends Controller {
  static targets = ["range", "input", "label", "hint"]
  static values = { stops: Array }

  connect() {
    this.update()
  }

  update() {
    const idx = Number(this.rangeTarget.value)
    const stop = this.stopsValue[idx]
    if (!stop) return

    const [value, label, hint] = stop
    this.inputTarget.value = value
    this.labelTarget.textContent = label
    this.hintTarget.textContent = hint
  }
}
